<template lang="html">
  <div id="text-page">
    <div class="container med-container">
      <div class="col-12 col-s-title">
        <h1 class="title"><span>Oficio de Aprobación del Contrato de Adhesión del Servicio de Telefonía Móvil en la modalidad de Prepago en favor de BLACKFON MX, S.A. de C.V.</span></h1>
      </div>

      <div class="body">
        <iframe class="iframe-pdf" src="public/pdfs/BLACKFON-MX_.pdf"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
